import { supabase } from "@/integrations/supabase/client";
import type {
  PlayerProfileInsert,
  PlayerProfileRecord,
  PlayerProfileUpdate,
} from "@/types/services/api-contracts";

import { requireAuthenticatedUser } from "./_core/auth";

export const profileService = {
  async getMine(): Promise<PlayerProfileRecord | null> {
    const user = await requireAuthenticatedUser();
    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("user_id", user.id)
      .maybeSingle();

    if (error) throw error;
    return data as PlayerProfileRecord | null;
  },

  async upsertMine(data: PlayerProfileUpdate): Promise<PlayerProfileRecord> {
    const user = await requireAuthenticatedUser();
    const payload: PlayerProfileInsert = {
      user_id: user.id,
      full_name: data.full_name ?? null,
      avatar_url: data.avatar_url ?? null,
      cover_url: data.cover_url ?? null,
      phone: data.phone ?? null,
      city: data.city ?? null,
      state: data.state ?? null,
      neighborhood: data.neighborhood ?? null,
      preferred_sports: data.preferred_sports ?? [],
      skill_level: data.skill_level ?? "beginner",
      preferred_position: data.preferred_position ?? null,
      preferred_play_times: data.preferred_play_times ?? [],
      public_visibility: data.public_visibility ?? true,
      bio: data.bio ?? null,
    };

    const { data: row, error } = await supabase
      .from("profiles")
      .upsert(payload, { onConflict: "user_id" })
      .select("*")
      .single();

    if (error) throw error;
    return row as PlayerProfileRecord;
  },
};
